import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { downloadPlayerIdCard, downloadTeamIdCard } from '../api/idcards.api';

const IDCardsPage: React.FC = () => {
  const { user } = useAuth();
  const [teamId, setTeamId] = useState('');
  const [playerId, setPlayerId] = useState('');
  const [teamLoading, setTeamLoading] = useState(false);
  const [playerLoading, setPlayerLoading] = useState(false);

  const triggerDownload = (blob: Blob, filename: string) => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  };

  const handleTeamDownload = async () => {
    if (!teamId.trim()) {
      return;
    }
    setTeamLoading(true);
    try {
      const blob = await downloadTeamIdCard(teamId);
      triggerDownload(blob, `team-${teamId}-idcard.pdf`);
    } catch (err) {
      // Silent fail for prototype.
    } finally {
      setTeamLoading(false);
    }
  };

  const handlePlayerDownload = async () => {
    if (!playerId.trim()) {
      return;
    }
    setPlayerLoading(true);
    try {
      const blob = await downloadPlayerIdCard(playerId);
      triggerDownload(blob, `player-${playerId}-idcard.pdf`);
    } catch (err) {
      // Silent fail for prototype.
    } finally {
      setPlayerLoading(false);
    }
  };

  return (
    <div className="container py-5">
      <div className="mb-3">
        <Link to={user ? '/dashboard' : '/'} className="btn btn-outline-secondary btn-sm">
          <i className="bi bi-arrow-left me-1"></i>
          {user ? 'Back to Dashboard' : 'Back to Home'}
        </Link>
      </div>
      <div className="mb-4">
        <h1 className="h3 section-title">ID Cards</h1>
        <p className="text-muted-soft">Download verified ID cards for game-day access.</p>
      </div>

      <div className="row g-4">
        <div className="col-lg-6">
          <div className="card card-surface h-100">
            <div className="card-body">
              <h4 className="mb-3">Team ID Card</h4>
              <label htmlFor="teamId" className="form-label">
                Team ID
              </label>
              <input
                id="teamId"
                type="text"
                className="form-control mb-3"
                value={teamId}
                onChange={(event) => setTeamId(event.target.value)}
                placeholder="Enter team ID"
              />
              <button
                type="button"
                className="btn btn-arena w-100"
                onClick={handleTeamDownload}
                disabled={teamLoading}
              >
                {teamLoading ? 'Downloading...' : 'Download Team Card'}
              </button>
            </div>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="card card-surface h-100">
            <div className="card-body">
              <h4 className="mb-3">Player ID Card</h4>
              <label htmlFor="playerId" className="form-label">
                Player ID
              </label>
              <input
                id="playerId"
                type="text"
                className="form-control mb-3"
                value={playerId}
                onChange={(event) => setPlayerId(event.target.value)}
                placeholder="Enter player ID"
              />
              <button
                type="button"
                className="btn btn-outline-secondary w-100"
                onClick={handlePlayerDownload}
                disabled={playerLoading}
              >
                {playerLoading ? 'Downloading...' : 'Download Player Card'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IDCardsPage;
